import { WebStorageStateStore, type UserManagerSettings } from 'oidc-client-ts'

const authConfig: UserManagerSettings = {
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  authority: import.meta.env.VITE_APP_AUTHORITY,
  client_id: import.meta.env.VITE_APP_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_APP_REDIRECT_URI,
  response_type: import.meta.env.VITE_APP_RESPONSE_TYPE,
  scope: import.meta.env.VITE_APP_SCOPE,
  post_logout_redirect_uri: import.meta.env.VITE_APP_POST_LOGOUT_REDIRECT_URI,
  response_mode: import.meta.env.VITE_APP_RESPONSE_MODE,
}

export { authConfig }
